import React from 'react';
import { Badge, Box, Typography } from '@mui/material';
import { Mail } from '@mui/icons-material';

interface UnreadMessageBadgeProps {
  unreadCount: number;
  onClick?: () => void;
}

export const UnreadMessageBadge: React.FC<UnreadMessageBadgeProps> = ({
  unreadCount,
  onClick
}) => {
  return (
    <Box onClick={onClick} sx={{ cursor: onClick ? 'pointer' : 'default', lineHeight: 1 }}>
      <Badge
        badgeContent={unreadCount > 0 ? unreadCount : 0}
        color="primary"
        sx={{
          '& .MuiBadge-badge': {
            fontSize: '0.6rem',
            height: '14px',
            minWidth: '14px'
          }
        }}
      >
        <Mail
          sx={{
            fontSize: '1rem',
            color: unreadCount > 0 ? 'primary.main' : 'text.secondary'
          }}
        />
      </Badge>
    </Box>
  );
};